import React from 'react';
import { DialogProps } from '@material-ui/core/Dialog';
import GetOutOnShift from '../../../assets/tutorial-graphics/my-activities/get_out_on_shift.png';
import { TutorialDialog, TutorialDialogStep } from '../../../common/dialogs/TutorialDialog';

const steps: Array<TutorialDialogStep> = [
  {
    label: 'Activity Report',
    description: (
      <>
        The Activity Report page is where you provide the organisation with <strong>impact data</strong> gathered while
        volunteering.
      </>
    ),
    image: GetOutOnShift,
  },
  {
    label: 'Activity Report',
    description: (
      <>
        Check out the <strong>Incomplete Reports</strong> tab to see if you need to provide the organisation with impact
        data on a recent activity.
      </>
    ),
    image: GetOutOnShift,
  },
];

const ActivityReportTutorialDialog = (props: DialogProps) => {
  const { open, onClose } = props;
  return <TutorialDialog open={open} onClose={onClose} steps={steps} />;
};

export { ActivityReportTutorialDialog };
